document.addEventListener('click', function (event) {
  var swatch = event.target.closest && event.target.closest('.everyday-card-swatches__swatch');
  if (!swatch || !swatch.dataset.variantImage) return;
  event.preventDefault();
  var card = swatch.closest('.everyday-card');
  if (!card) return;
  var img = card.querySelector('img');
  if (img) {
    if (swatch.dataset.variantSrcset) {
      img.srcset = swatch.dataset.variantSrcset;
    } else {
      img.removeAttribute('srcset');
    }
    img.src = swatch.dataset.variantImage;
  }
  var group = swatch.parentElement;
  if (group) {
    group.querySelectorAll('.everyday-card-swatches__swatch--active').forEach(function (el) {
      el.classList.remove('everyday-card-swatches__swatch--active');
    });
  }
  swatch.classList.add('everyday-card-swatches__swatch--active');
});
